module.exports=function(scope){ return `<script src="../ZoomAuthentication.js/ZoomAuthentication.js"></script>
<script>
    // OPTIONAL: Specify a custom directory to load FaceTec resources from.
    ZoomSDK.setResourceDirectory("./INSERT_CUSTOM_DIRECTORY_HERE");
</script>
`};


// WEBPACK FOOTER //
// ./src/resources/code/web/quickstart/custom-resources.html.tpl